import { combineEpics } from 'redux-observable';

import * as data from './data/epics';
import * as entityHierarchies from './entity-hierarchies/epics';
import * as insights from './insights/epics';
import * as triggers from './triggers';

export default combineEpics(
    ...Object.values(entityHierarchies),
    ...Object.values(triggers),
    ...Object.values(insights),
    ...Object.values(data)
);
